export const RECOVERY_DASHBOARD_URL = 'https://recovery.zerodev.app';
export const KERNEL_API_URL = 'https://kernel-api.zerodev.app';
